import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { astriskStyle } from 'src/styles/CommonStyles.styled';

export const DetailsMainContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
`;

export const TimeZone = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-between;
`;
export const RowDiv = styled.span`
    display: inline-flex;
    width: 100%;
    justify-content: space-between;
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '16px')};
`;

export const PatientRowDiv = styled.span`
    display: inline-flex;
    width: 100%;
    justify-content: space-between;
    ${media.mobileDevice`
        margin-top: 16px;
    `};
`;
export const RadioRowDiv = styled.span`
    display: inline-flex;
    width: ${({ width }) => (width ? width : '100%')};
    margin-bottom: ${({ marginBottom }) => marginBottom};
    word-break: ${({ wordBreak }) => wordBreak};
`;
export const OptionContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin: 0;
    padding: 0;
    cursor: auto;
    padding: ${({ padding }) => (padding ? padding : '5px 10px')};
    & .template {
        font-size: 14px;
        color: #140f4b;
        font-family: AvenirNextWorld Regular;
    }
`;
export const AlertMsgContainer = styled.div`
    display: flex;
`;

export const SelectedPlaceholder = styled.div`
    color: 'rgb(191 191 191)';
`;

export const ImageContainer = styled.div`
    display: flex;
    margin-right: ${(props) =>
        props.marginRight ? props.marginRight : 'unset'};
    height: 27px;
    width: 25px;
    align-items: center;
    opacity: 1;
    justify-content: center;
    :active {
        box-shadow: -1px -1px 1px #cfe8fe;
    }
`;
export const OuterContainer = styled.div`
    display: ${(props) => (props.display ? props.display : 'flex')};
    flex-direction: ${(props) => (props.isLoadMore ? 'column' : 'row')};
    margin: 0;
    padding-left: 0;
    width: 100%;
    position: relative;
    margin: ${(props) => (props.margin ? props.margin : '0')};
`;
export const AccountFieldTitle = styled.label`
    color: #140f4b;
    font-size: 14px;
    //HCP id slanting
    //font-family: AvenirNextWorld Regular;
    font-family: ${(props) =>
        props.fontFamily ? props.fontFamily : 'AvenirNextWorld Regular'};
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: ${(props) => (props.width ? props.width : 'auto')};
    margin: ${(props) => (props.margin ? props.margin : '0px')};
    cursor: pointer;
    ${media.mediumDevice`
         max-width: ${(props) => (props.iPadwidth ? props.iPadwidth : '25vw')};
    `}
    ${media.mobileDevice`
        max-width: ${(props) =>
            props.mobileWidth ? props.mobileWidth : 'auto'};
    `}
`;

export const AccountFieldAddress = styled.label`
    color: #140f4b;
    opacity: 0.7;
    font-size: 12px;
    font-family: AvenirNextWorld Regular;
    display: inline-block;
    /* margin-right: 10px; */
    max-width: ${(props) => (props.width ? props.width : 'auto')};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    margin: ${(props) => (props.margin ? props.margin : '0px')};
    ${media.mediumDevice`
         max-width: ${(props) => (props.iPadwidth ? props.iPadwidth : '25vw')};
    `}
    ${media.mobileDevice`
        max-width: ${(props) =>
            props.mobileWidth ? props.mobileWidth : 'auto'};
    `}
`;
export const OptionalLoadMoreView = styled.div`
    background-color: #f5f5f5;
    height: ${({ height }) => (height ? height : '200px')};
    display: flex;
    justify-content: center;
    align-items: center;
    // some space is left after grey message area
    margin: ${({ margin }) => (margin ? margin : '10px 0 0 0')};
    flex-direction: column;
    width: 100%;
    & p {
        color: #4f4f4f;
        font-size: 18px;
        font-family: AvenirNextWorld Regular;
        text-align: center;
        margin: 0 0 10px;
    }
    & button {
        padding: 10px;
        color: #1010eb;
        border: 1px solid #1010eb;
        border-radius: 20px;
        text-align: center;
        padding: 5px 13px;
        font-family: AvenirNextWorld Demi;
        font-size: 15px;
        background: #f5f5f5;
    }
`;

export const SurgeryDateView = styled.div`
    display: inline-flex;
    width: 100%;
    align-items: center;
    & p {
        padding: 0;
        margin: 0;
        text-align: center;
        width: 40%;
        color: #202124;
        font-size: 14px;
        font-family: 'AvenirNextWorld Regular';
    }
`;
export const RequestDeliveryDateView = styled.div`
    display: inline-flex;
    width: 100%;
    align-items: center;
    margin-bottom: ${({ marginBottomLarge }) =>
        marginBottomLarge ? '30px' : null};
    & p {
        padding: 0;
        margin: 0;
        text-align: center;
        width: 40%;
        color: #202124;
        font-size: 14px;
        font-family: 'AvenirNextWorld Regular';
    }
    @media only screen and (orientation: landscape) {
        margin-bottom: ${({ marginBottom }) => (marginBottom ? '30px' : null)};
    }
`;

// export const RequestDeliveryNote = styled.div`
//     display: inline-flex;
//     width: 100%;
//     align-items: center;
//     padding: 0;
//     margin: ${({ setMargin }) => (setMargin ? setMargin : ' 0 10px')};
//     text-align: center;
//     width: 40%;
//     color: #202124;
//     font-size: ${({ setFont }) => (setFont ? setFont : '15px')};
//     font-family: 'AvenirNextWorld Regular';
//     line-height: ${({ setLineHeight }) =>
//         setLineHeight ? setLineHeight : 1.5};
//     @media only screen and (min-width: 844px) and (max-width: 844px) and (min-height: 390px) and (max-height: 390px) and (orientation: landscape) and (-webkit-device-pixel-ratio: 3) {
//         margin: 0 20px;
//         font-size: 14px;
//         line-height: 1.5;
//     }
//     @media only screen and (min-width: 430px) and (max-width: 430px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 3) {
//         margin: 0 15px;
//         font-size: 14px;
//     }
//     @media only screen and (min-width: 360px) and (max-width: 360px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 4) {
//         margin: 0 20px;
//         font-size: 11px;
//         line-height: 1.5;
//     }
//     @media only screen and (min-width: 740px) and (max-width: 740px) and (orientation: landscape) and (-webkit-device-pixel-ratio: 4) {
//         font-size: 12px;
//     }
//     @media only screen and (min-width: 768px) and (max-width: 768px) and (orientation: portrait) {
//         font-size: 13px;
//     }
//     @media only screen and (min-width: 1024px) and (max-width: 1024px) and (orientation: landscape) {
//         margin: 0 20px;
//         font-size: 15px;
//         line-height: 1.5;
//     }
//     @media only screen and (min-width: 820px) and (max-width: 820px) and (orientation: portrait) {
//         margin: 0 15px;
//         font-size: 14px;
//     }
// `;
export const DatePickerDiv = styled.div`
    border: 2px solid #ebeded;
    border-radius: 6px;
    display: flex;
    align-items: center;
    width: 20vw;
    height: 40px;
    justify-content: space-around;
    ${media.mobileDevice`
        width: 42vw;
        height: 40px;
    `};
`;

export const SurgeryTimeView = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;
export const PatientView = styled.div`
    flex-direction: row;
    display: flex;

    ${media.mobileDevice`
    flex-wrap: wrap;
    `};
`;

export const Title = styled.div`
    font-family: AvenirNextWorld demi;
    color: #202124;
    font-size: 14px;
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '8px'};

    ${astriskStyle};
    @media only screen and (max-device-width: 375px) {
        font-size: 12px;
    }
`;

export const MainContainerItems = styled.div`
    width: ${({ width }) => (width ? width : '47%')};
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    margin-bottom: ${({ setMarginBottom, isReplenish, isSurgery }) =>
        setMarginBottom
            ? isReplenish
                ? setMarginBottom
                : isSurgery
                ? '0px'
                : '16px'
            : '0px'};
    margin-left: ${({ setMarginleft }) =>
        setMarginleft ? setMarginleft : '0px'};
    margin-top: ${({ setMarginTop }) =>
        setMarginTop ? setMarginTop : '0px'};

    ${media.mobileDevice`
        width: 100%;
        margin-bottom: ${({ mbMarginBottom }) => mbMarginBottom};
        margin-left: 0px;
    `}
    @media screen and (min-width: 768px) and (max-width: 768px) and (orientation: portrait){
     margin-left: ${({ ipadMarginLeft }) => (ipadMarginLeft ? ipadMarginLeft : '')};
     width:${({ iPadwidth }) => (iPadwidth ? iPadwidth : '')};

    }

`;

export const Subtitle = styled.div`
    font-size: 16px;
    font-family: AvenirNextWorld Regular;
`;
export const SurgeryDateErrorDiv = styled.div`
    margin: ${({ setMargin }) =>
        setMargin ? '10px 5px 30px 0' : '10px 5px 8px 0'};
`;
export const SurgeryDateErrorTitlerDiv = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;
export const SurgeryDateRedText = styled.div`
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '13px')};
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Regular'};
    color: red;
    margin: ${({ margin }) => (margin ? margin : '0')};
    ${media.mobileDevice`
        font-size: ${({ mbFontSize }) => (mbFontSize ? mbFontSize : '13px')};
    `}
`;

export const CaseCoverageDiv = styled.div`
    max-width: 462px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    ${media.mediumDevice`
       max-width: 35vw;
    `}
    ${media.smalDevice`
       max-width: 37vw;
    `}

    ${media.mobileDevice`
       max-width: 71vw;
    `}
`;

export const DatePickerIcon = styled.img.attrs((props) => ({
    src: props.defaultImg,
    alt: props.name,
}))``;

export const StyledDiv = styled.div`
    width: ${({ width }) => (width ? width : '40px')};
`;
export const ImgDiv = styled.div`
    width: 24px;
    align-items: flex-start;
    display: flex;
    justify-content: center;
`;

export const LineSeparator = styled.hr`
    border: 0;
    border-top: 2px solid #e8e8e8;
    box-sizing: content-box;
    height: 0;
    overflow: visible;
    margin: 0px 8px -1px 8px;
`;
export const InputContainer = {
    height: '40px',
    width: '100%',
    background: '#00000029',
};

export const ContactNumberContainer = styled.div`
    position: relative;
`;

export const ImageTag = styled.img`
    position: ${({ position }) => (position ? position : 'unset')};
    top: ${({ top }) => (top ? top : 'unset')};
    right: ${({ right }) => (right ? right : 'unset')};
    cursor: ${({ cursor }) => (cursor ? cursor : 'unset')};
    margin: ${({ margin }) => (margin ? margin : 'unset')};
`;

export const OptionAccountContainer = styled.div`
    width: calc(100% - 24px);
`;

export const SurgeryDateViewAndNumberContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    padding-bottom: 1px;
`;

export const SurgeryDateViewAndNumber = styled.div`
    margin: ${({
        isConsignmentAdd,
        isConsignmentBilling,
        isReportReplenishment,
        isSurgery,
        isReplenish,
    }) =>
        isConsignmentAdd ||
        isConsignmentBilling ||
        isSurgery ||
        isReportReplenishment ||
        isReplenish
            ? ''
            : '5px'};
    width: ${({
        isConsignmentAdd,
        isReportReplenishment,
        shipToAddress,
        width,
    }) =>
        isConsignmentAdd
            ? '100%'
            : isReportReplenishment && width
            ? '46.5%'
            : isReportReplenishment
            ? '46%'
            : shipToAddress
            ? '100%'
            : width
            ? width
            : ''};
    display: ${({ isConsignmentAdd }) => (isConsignmentAdd ? 'flex' : '')};
    flex-direction: ${({ isConsignmentAdd }) =>
        isConsignmentAdd ? 'column' : ''};
    margin-left: ${({ isSurgeryleftMarginDesk }) =>
        isSurgeryleftMarginDesk ? '20px' : ''};
    margin: ${({ isConsignmentAdd, mobile }) =>
        isConsignmentAdd && !mobile
            ? ' 14px 0 8px 0'
            : mobile
            ? ' 0px 0 8px 0'
            : ''};
    margin-bottom: ${({
        isConsignmentAdd,
        isConsignmentBillingMargin,
        isSurgery,
        isReplenishBtm,
    }) =>
        isConsignmentAdd || isConsignmentBillingMargin
            ? '16px'
            : isSurgery
            ? '-10px'
            : isReplenishBtm
            ? '10px'
            : ''};
    margin-right: ${({
        isConsignmentAdd,
        isConsignmentBillingMarginRight,
        isReplenish,
    }) =>
        isConsignmentAdd
            ? '0'
            : isConsignmentBillingMarginRight
            ? '0px'
            : isReplenish
            ? isReplenish
            : ''};

    margin-top: ${({ marginTop }) => (marginTop ? '10px' : '')};

    ${media.mobileDevice`
        width: 100%;
         margin-left: ${({
             isConsignmentAdd,
             isConsignmentBilling,
             isSurgeryleftMargin,
         }) =>
             isConsignmentAdd || isConsignmentBilling
                 ? '0px'
                 : isSurgeryleftMargin
                 ? '10px'
                 : ''};
         margin-right:${({
             isConsignmentAdd,
             isConsignmentBilling,
             isSurgery,
         }) =>
             isConsignmentAdd || isConsignmentBilling || isSurgery
                 ? '0px'
                 : ''};
        margin: ${({
            isSurgery,
            isConsignmentBilling,
            isReportReplenishment,
            isConsignmentAdd,
        }) =>
            isSurgery ||
            isConsignmentBilling ||
            isReportReplenishment ||
            isConsignmentAdd
                ? ''
                : '5px'};
        margin-top: ${({
            isConsignmentAdd,
            marginTop,
            isReportReplenishment,
            mbMarginTop,
        }) =>
            isReportReplenishment
                ? mbMarginTop
                : isConsignmentAdd && marginTop && marginTop};
    `}

    @media only screen and (min-width: 768px) and (max-width: 768px) and (orientation: portrait), 
     screen and (min-width: 820px) and (max-width: 820px) and (orientation: portrait),
      screen and (min-width: 1024px) and (max-width: 1024px) and (orientation: portrait) {
        width: ${({ isConsignmentAdd, isSurgeryDate }) =>
            isConsignmentAdd || isSurgeryDate ? '100%' : ''};
    }
`;

export const ResponsiveSelect = styled.div`
    width: 100%;

    @media only screen and (max-device-width: 375px) {
        width: 100%;
        font-size: 12px;
    }
`;

export const ParagraphWithMargin = styled.p`
  margin-bottom: 7px;
`;

export const ParagraphSmall = styled.p`
  font-size: 12px;
`;

export const OptionTextWrapper = styled.div`
  width: 85%;
  cursor: pointer;
`;

export const OptionLabel = styled.label`
  cursor: pointer;
  &.template {
    /* keep existing styles for .template class if any */
  }
`;

export const ActionContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
  width: 15%;
`;

export const IconImage = styled.img`
  width: ${(props) => props.width || '20px'};
  height: ${(props) => props.height || '20px'};
  cursor: pointer;
`;

export const BillToTextWrapper = styled.div`
  width: 85%;
  cursor: pointer;
`;

export const BillToLabel = styled.label`
  cursor: pointer;
`;

export const ActionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
  width: 15%;
`;
